export default __webpack_public_path__ + "Montserrat-SemiBold.ttf?2f7a846126c7d5ee91636209cd78214b";